// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "pfx-CommunityButton-module__button--UIJlP";
var _7 = "pfx-CommunityButton-module__button-flex--tB6Xe";
var _8 = "1140px";
var _9 = "940px";
var _a = "100%";
var _b = "15px";
var _c = "620px";
var _d = "#f53535";
var _e = "rgba(0,0,0,.2)";
var _f = "rgba(255,255,255,.38)";
var _10 = ".38";
var _11 = "rgba(255,255,255,.2)";
var _12 = "#0025ff";
var _13 = "pfx-CommunityButton-module__glitch-anim--cnieL";
var _14 = "pfx-CommunityButton-module__glitch-anim-2--vhzGw";
var _15 = "#f60";
var _16 = "#41ead4";
var _17 = "#2cdd78";
var _18 = "#66ab23";
var _19 = "#f5f5f5";
var _1a = "#c3c3c3";
var _1b = "#ececec";
var _1c = "#252525";
var _1d = "#272727";
var _1e = "#c6c6c5";
var _1f = "#333";
var _20 = "#3c3c3c";
var _21 = "#9c9b9b";
var _22 = "#8c8c8c";
var _23 = "#6f6f6e";
var _24 = "#3c3c3b";
var _25 = "#373737";
var _26 = "#6a6a69";
var _27 = "#6f6f6f";
var _28 = "#9f9e9e";
var _29 = "#282828";
var _2a = "#828181";
var _2b = "#1d1d1d";
var _2c = "#979797";
var _2d = "#9c9b9b";
var _2e = "#a7a7a6";
var _2f = "#c6c6c5";
var _30 = "#d8d8d7";
var _31 = "#dddddc";
var _32 = "72px";
var _33 = "40px";
var _34 = "36px";
var _35 = "25px";
var _36 = "18px";
var _37 = "13px";
var _38 = "#0025ff";
var _39 = "rgba(255,255,255,.12)";
var _3a = "#6535f5";
var _3b = "2px";
var _3c = "56px";
var _3d = "56px";
var _3e = "#41ead4";
var _3f = "#f60";
var _40 = "#f83600";
var _41 = "#881f00";
var _42 = "18px";
var _43 = "15px";
var _44 = "pfx-CommunityButton-module__pfx-icon--MOPy3";
var _45 = "red";
var _46 = "13px";
var _47 = "rgba(255,255,255,.07)";
var _48 = "#35465c";
var _49 = "#55acee";
var _4a = "#fff";
var _4b = "#ffce36";
var _4c = "#ffcd00";
var _4d = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "button", _7 as "buttonFlex", _8 as "containerLarge", _9 as "containerMedium", _a as "containerMobile", _b as "containerPaddingMobile", _c as "containerSmall", _d as "danger", _e as "darkElement", _f as "disabled", _10 as "disabledOpacity", _11 as "extraLightElement", _12 as "facebook", _13 as "glitchAnim", _14 as "glitchAnim2", _15 as "google", _16 as "green", _17 as "green2", _18 as "greenColor", _19 as "grey1", _1a as "grey10", _1b as "grey2", _1c as "grey25", _1d as "grey27", _1e as "grey3", _1f as "grey33", _20 as "grey3C", _21 as "grey4", _22 as "grey41", _23 as "grey5", _24 as "grey6", _25 as "grey61", _26 as "grey6A", _27 as "grey6F", _28 as "grey7", _29 as "grey8", _2a as "grey82", _2b as "grey9", _2c as "grey97", _2d as "grey9C", _2e as "greyA7", _2f as "greyC6", _30 as "greyD8", _31 as "greyDd", _32 as "header1", _33 as "header2", _34 as "header3", _35 as "header4", _36 as "header5", _37 as "header6", _38 as "klein", _39 as "lightElement", _3a as "lilac", _3b as "menuBorder", _3c as "menuHeight", _3d as "menuMobileHeight", _3e as "ocean", _3f as "orange", _40 as "orange2", _41 as "orangeDark", _42 as "paragraph", _43 as "paragraphSmall", _44 as "pfxIcon", _45 as "red", _46 as "subHeaderSmall", _47 as "subtleLightElement", _48 as "tumblr", _49 as "twitter", _4a as "white", _4b as "yellow", _4c as "yellowDeep", _4d as "youtube" }
